import { emptySplitApi as api } from '../../emptyApi';

export interface AuditLogAccountSummary {
  id: number;
  email: string;
  first_name: string;
  last_name: string | null;
  name: string;
}

export interface AuditLogOrganizationSummary {
  id: number;
  name: string | null;
}

export type AuditLogOp = 'I' | 'U' | 'D';

export interface AuditLogEntry {
  id: number;
  occurred_at: string;
  actor_account_id: number;
  actor: AuditLogAccountSummary | null;
  on_behalf_of_account_id: number | null;
  on_behalf_of: AuditLogAccountSummary | null;
  impersonation_session_id: number | null;
  organization_id: number | null;
  organization: AuditLogOrganizationSummary | null;
  table_name: string;
  row_id: string;
  op: AuditLogOp;
  before: Record<string, unknown> | null;
  after: Record<string, unknown> | null;
  request_id: string | null;
  stack: string;
  ip_address: string | null;
  capture_status: string;
}

export interface AuditLogListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: AuditLogEntry[];
}

export interface ListAuditLogApiArg {
  organization_id?: number;
  actor_account_id?: number;
  table_name?: string;
  op?: AuditLogOp;
  occurred_at_from?: string;
  occurred_at_to?: string;
  limit?: number;
  offset?: number;
}

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    listAuditLog: build.query<AuditLogListResponse, ListAuditLogApiArg>({
      query: (queryArg) => ({
        url: '/api/admin/v1/audit-log/',
        params: {
          organization_id: queryArg.organization_id,
          actor_account_id: queryArg.actor_account_id,
          table_name: queryArg.table_name,
          op: queryArg.op,
          occurred_at_from: queryArg.occurred_at_from,
          occurred_at_to: queryArg.occurred_at_to,
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    listAuditLogTables: build.query<string[], void>({
      query: () => ({ url: '/api/admin/v1/audit-log/tables/' }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useListAuditLogQuery,
  useListAuditLogTablesQuery,
} = injectedRtkApi;
